// A particular supplier's product
export default class SupplierProduct {
    id: string = "";
    name: string = "";
    description: string | null = null;
    supplierProductName: string | null = null;
}

export class ExtendedSupplierProduct {
    id: string = "";
    name: string = "";
    description: string | null = null;
    supplierProductName: string | null = null;
    fullName: string = "";

    constructor(supplierProduct: SupplierProduct) {
        this.id = supplierProduct.id;
        this.name = supplierProduct.name;
        this.description = supplierProduct.description;
        this.supplierProductName = supplierProduct.supplierProductName;

        this.fullName = "";
        if (this.supplierProductName != null && this.name != null) {
            this.fullName = this.supplierProductName + " (" + this.name + ")";
        } else if (this.supplierProductName != null) {
            this.fullName = this.supplierProductName;
        } else if (this.name != null) {
            this.fullName = this.name;
        }
    }
}
